import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = {
  key: 0,
  class: "prefix"
}
const _hoisted_3 = {
  key: 1,
  class: "sufix"
}
const _hoisted_4 = {
  key: 1,
  class: "error-message"
}

import { computed, ref, watchEffect } from "vue";
import moment from "moment";

import Calendar from "primevue/calendar";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-date',
  props: {
    width: { default: "100%" },
    height: { default: "2.5rem" },
    radius: { default: "0.375rem" },
    background: { default: "#fff" },
    placeholder: {},
    value: {},
    disabled: { type: Boolean },
    mask: { default: "dd/mm/yy" },
    valueMask: {}
  },
  emits: ["update:modelValue", "select-date", "key:enter"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v3b5675f8": (_ctx.width),
  "v4e74e1a9": (_ctx.height),
  "v5f4abd14": (_ctx.radius),
  "v8f56d6a0": (_ctx.background)
}))

const props = __props;

const emit = __emit;

const internalValue = ref<Date | null>(null);

const maskFormat = computed(() =>
  props.mask ? props.mask?.replace("yy", "YYYY")?.toUpperCase() : "DD/MM/YYYY"
);

function update(value: any) {
  const date = moment(value, maskFormat.value).format("YYYY-MM-DD");

  emit("update:modelValue", date);
}

watchEffect(() => {
  if (!props.value) {
    internalValue.value = null;
  }

  if (props.value && props.valueMask) {
    const valueFormat = moment(props.value, props.valueMask).format(
      maskFormat.value
    );

    internalValue.value = valueFormat;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-input", { disabled: __props.disabled }])
  }, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { error: _ctx.$slots.error }])
    }, [
      (_ctx.$slots.prefix)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "prefix")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["input", { pref: _ctx.$slots.prefix, suf: _ctx.$slots.sufix }])
      }, [
        _createVNode(_unref(Calendar), {
          class: "calendar",
          modelValue: internalValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
          dateFormat: props.mask,
          placeholder: props.placeholder,
          manualInput: false,
          showIcon: "",
          fluid: "",
          iconDisplay: "input",
          onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (update($event)))
        }, null, 8, ["modelValue", "dateFormat", "placeholder"])
      ], 2),
      (_ctx.$slots.sufix)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "sufix")
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.$slots.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "error")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})